export const handleLogoClick = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const handleProductClick = () => {
  const learningCenter = document.getElementById('learning-center');
  if (learningCenter) {
    learningCenter.scrollIntoView({ behavior: 'smooth' });
  }
};
